import React from "react";
import { Button } from "react-bootstrap";
import { turkishCurrencyFormatterNoPrecision } from "../utils";

export default function AnalyticRaportAdetlerVeTutarlar(props) {
  const {
    dailyReport,
    selectedProduct,
    setSelectedProduct,
    selectedProductGift,
    setSelectedProductGift,
  } = props;
  return (
    <>
      <table className="table table-bordered table-striped table-sm">
        <thead>
          <tr>
            <th></th>
            <th className="text-end">Adet</th>
            <th className="text-end">Tutar</th>
            <th className="text-end">Karlılık</th>
          </tr>
        </thead>
        <tbody>
          {dailyReport.products.map((p) => (
            <>
              <tr key={p.product}>
                <td className="text-bold">
                  {(p.features.length > 1 ||
                    (p.features.length === 1 &&
                      p.features[0].answers?.length > 0)) && (
                    <Button
                      className="p-0 pe-1 ps-1"
                      variant="link"
                      onClick={() => {
                        if (selectedProduct.product === p.product) {
                          setSelectedProduct({ product: "" });
                        } else {
                          setSelectedProduct(p);
                        }
                      }}
                    >
                      {selectedProduct.product === p.product ? (
                        <i className="fa fa-minus"></i>
                      ) : (
                        <i className="fa fa-plus"></i>
                      )}
                    </Button>
                  )}
                  {(p.features.length === 1
                    ? (p.features[0].name
                        ? p.features[0].name.slice(0, 30)
                        : "") + " "
                    : "") + p.name}
                </td>
                <td className="text-end">
                  {p.totalAmount}
                  <span className="small-font text-danger">
                    {p.totalPriceChangeCount
                      ? " " + p.totalPriceChangeCount
                      : ""}
                  </span>
                </td>
                <td className="text-end">
                  {!!p.totalRelativePrice && (
                    <>
                      <span className="small-font text-muted">
                        {"+ " +
                          turkishCurrencyFormatterNoPrecision(
                            p.totalRelativePrice
                          )}
                      </span>{" "}
                      &nbsp;
                    </>
                  )}
                  <span>
                    {turkishCurrencyFormatterNoPrecision(
                      p.totalPrice + p.totalRelativePrice
                    )}
                  </span>
                  <span className="small-font text-danger">
                    {p.totalPriceChange
                      ? " " +
                        turkishCurrencyFormatterNoPrecision(p.totalPriceChange)
                      : ""}
                  </span>
                </td>
                <td className="text-end">
                  {!!p.productCost &&
                    (!p.features ||
                      p.features.filter((f) => f.featureCost).length === 0) && (
                      <>
                        <span className="text-success">
                          {turkishCurrencyFormatterNoPrecision(
                            p.totalPrice - p.totalAmount * p.productCost
                          )}
                          /
                        </span>
                        <span className="small-font text-danger">
                          {p.productCost.toFixed(2)}/
                        </span>
                        <span className="small-font text-success">
                          {p.productSalePrice > p.productCost
                            ? turkishCurrencyFormatterNoPrecision(
                                p.productSalePrice
                              )
                            : turkishCurrencyFormatterNoPrecision(
                                p.totalPrice / p.totalAmount
                              )}
                        </span>
                      </>
                    )}
                  {p.features &&
                    p.features.length > 0 &&
                    p.features.filter((f) => f.featureCost).length > 0 &&
                    p.features.length > 1 && (
                      <span className="text-success">
                        {turkishCurrencyFormatterNoPrecision(
                          p.features.reduce(
                            (s, f) =>
                              s +
                              (f.featureCost
                                ? f.totalPrice - f.totalAmount * f.featureCost
                                : 0),
                            0
                          )
                        )}
                      </span>
                    )}
                  {p.features &&
                    p.features.length > 0 &&
                    p.features.filter((f) => f.featureCost).length > 0 &&
                    p.features.length === 1 && (
                      <>
                        <span className="text-success">
                          {turkishCurrencyFormatterNoPrecision(
                            p.features[0].totalPrice -
                              p.features[0].totalAmount *
                                p.features[0].featureCost
                          )}
                          /
                        </span>
                        <span className="small-font text-danger">
                          {p.features[0].featureCost.toFixed(2)}/
                        </span>
                        <span className="small-font text-success">
                          {p.features[0].featureSalePrice >
                          p.features[0].featureCost
                            ? turkishCurrencyFormatterNoPrecision(
                                p.features[0].featureSalePrice
                              )
                            : turkishCurrencyFormatterNoPrecision(
                                p.features[0].totalPrice /
                                  p.features[0].totalAmount
                              )}
                        </span>
                      </>
                    )}
                </td>
              </tr>
              {p.product === selectedProduct.product &&
                selectedProduct.features.map((f) => (
                  <>
                    {selectedProduct.features.length > 1 && (
                      <tr className="table-active table-info" key={f.name}>
                        <td>
                          <i
                            className="fa fa-circle p-0 ps-2 pe-2 ms-2 mb-1 text-primary"
                            style={{
                              fontSize: "8px",
                              verticalAlign: "middle",
                            }}
                          ></i>
                          {f.name}
                        </td>
                        <td className="text-end">
                          {f.totalAmount}
                          <span className="small-font text-danger">
                            {f.totalPriceChangeCount
                              ? " " + f.totalPriceChangeCount
                              : ""}
                          </span>
                        </td>
                        <td className="text-end">
                          {!!f.totalRelativePrice && (
                            <>
                              <span className="small-font text-muted">
                                {"+ " +
                                  turkishCurrencyFormatterNoPrecision(
                                    f.totalRelativePrice
                                  )}
                              </span>{" "}
                              &nbsp;
                            </>
                          )}
                          {turkishCurrencyFormatterNoPrecision(
                            f.totalPrice + (f.totalRelativePrice || 0)
                          )}
                          <span className="small-font text-danger">
                            {f.totalPriceChange
                              ? " " + f.totalPriceChange.toFixed(2)
                              : ""}
                          </span>
                        </td>
                        <td className="text-end">
                          {!!f.featureCost && (
                            <>
                              <span className="text-success">
                                {turkishCurrencyFormatterNoPrecision(
                                  f.totalPrice - f.totalAmount * f.featureCost
                                )}
                                /
                              </span>
                              <span className="small-font text-danger">
                                {f.featureCost.toFixed(2)}/
                              </span>
                              <span className="small-font text-success">
                                {f.featureSalePrice > f.featureCost
                                  ? f.featureSalePrice.toFixed(2)
                                  : (f.totalPrice / f.totalAmount).toFixed(2)}
                              </span>
                            </>
                          )}
                        </td>
                      </tr>
                    )}
                    {f.answers
                      ?.sort((a) => (a.answerProduct ? -1 : 1))
                      .map((a) => (
                        <tr
                          className={
                            a.answerProduct
                              ? "table-active table-light"
                              : "table-active table-danger"
                          }
                          key={a.answer}
                        >
                          <td>
                            &nbsp;&nbsp;&nbsp;
                            <i
                              className={
                                a.answerProduct
                                  ? "fa fa-certificate p-0 ps-2 pe-2 ms-2 mb-1 text-warning"
                                  : "fa fa-star p-0 ps-2 pe-2 ms-2 mb-1 text-danger"
                              }
                              style={{
                                fontSize: "8px",
                                verticalAlign: "middle",
                              }}
                            ></i>
                            <span>{a.answer?.slice(0, 30)}</span>
                            {a.answerProduct && (
                              <>
                                &nbsp;
                                <span className="small-font text-muted">
                                  ({a.answerProductName})
                                </span>
                              </>
                            )}
                          </td>
                          <td className="text-end">{a.totalAmount}</td>
                          <td className="text-end">
                            <span
                              className={
                                a.answerProduct && "textDecorationLine"
                              }
                            >
                              {turkishCurrencyFormatterNoPrecision(
                                a.totalPrice
                              )}
                            </span>
                          </td>
                          <td className="text-end"></td>
                        </tr>
                      ))}
                  </>
                ))}
            </>
          ))}
          {dailyReport.productsOfStaff.length > 0 && (
            <tr>
              <td colSpan={4}>
                <h5 className="text-danger" style={{ textAlign: "center" }}>
                  {"Personel ve İkramlar"}
                </h5>
              </td>
            </tr>
          )}
          {dailyReport.productsOfStaff.map((p) => (
            <>
              <tr className="table-warning" key={p.product}>
                <td className="text-bold">
                  {(p.features.length > 1 ||
                    (p.features.length === 1 &&
                      p.features[0].answers?.length > 0)) && (
                    <Button
                      variant="link"
                      onClick={() => {
                        if (selectedProductGift.product === p.product) {
                          setSelectedProductGift({ product: "" });
                        } else {
                          setSelectedProductGift(p);
                        }
                      }}
                    >
                      {selectedProductGift.product === p.product ? (
                        <i className="fa fa-minus"></i>
                      ) : (
                        <i className="fa fa-plus"></i>
                      )}
                    </Button>
                  )}
                  {(p.features.length === 1
                    ? (p.features[0].name ? p.features[0].name : "") + " "
                    : "") + p.name}
                </td>
                <td className="text-end">{p.totalAmount}</td>
                <td className="text-end isGift">
                  {turkishCurrencyFormatterNoPrecision(
                    p.totalPrice + (p.totalRelativePrice || 0)
                  )}
                </td>
                <td></td>
              </tr>
              {p.product === selectedProductGift.product &&
                selectedProductGift.features.map((f) => (
                  <>
                    {selectedProductGift.features.length > 1 && (
                      <tr className="table-active" key={f.name || "yok"}>
                        <td>
                          <ul>
                            <li>{f.name}</li>
                          </ul>
                        </td>
                        <td className="text-end">{f.totalAmount}</td>
                        <td className="text-end isGift">
                          {turkishCurrencyFormatterNoPrecision(
                            f.totalPrice + f.totalRelativePrice
                          )}
                        </td>
                        <td></td>
                      </tr>
                    )}
                    {f.answers
                      ?.filter((a) => !a.answerProduct)
                      .map((a) => (
                        <tr
                          className={
                            a.answerProduct
                              ? "table-active table-light"
                              : "table-active table-danger"
                          }
                          key={a.answer}
                        >
                          <td>
                            &nbsp;&nbsp;&nbsp;
                            <i
                              className={
                                a.answerProduct
                                  ? "fa fa-certificate p-0 ps-2 pe-2 ms-2 mb-1 text-warning"
                                  : "fa fa-star p-0 ps-2 pe-2 ms-2 mb-1 text-danger"
                              }
                              style={{
                                fontSize: "8px",
                                verticalAlign: "middle",
                              }}
                            ></i>
                            <span>{a.answer?.slice(0, 30)}</span>
                            {a.answerProduct && (
                              <>
                                &nbsp;
                                <span className="small-font text-muted">
                                  ({a.answerProductName})
                                </span>
                              </>
                            )}
                          </td>
                          <td className="text-end">{a.totalAmount}</td>
                          <td className="text-end">
                            <span
                              className={
                                a.answerProduct && "textDecorationLine"
                              }
                            >
                              {turkishCurrencyFormatterNoPrecision(
                                a.totalPrice
                              )}
                            </span>
                          </td>
                          <td className="text-end"></td>
                        </tr>
                      ))}
                  </>
                ))}
            </>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td className="text-end">
              {turkishCurrencyFormatterNoPrecision(
                dailyReport.products.reduce(
                  (a, p) => a + p.totalPrice + p.totalRelativePrice,
                  0
                )
              )}
            </td>
          </tr>
        </tfoot>
      </table>
    </>
  );
}
